import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

/* Modulos */
import { AppRoutingModule } from './app-routing.module';
import { HomeModule } from './modules/home/home.module';
import { NavigationModule } from './modules/navigation/navigation.module';
import { AuthModule } from './modules/auth/auth.module';
import { FederationModule } from './modules/federation/federation.module';
import { KidsModule } from './modules/kids/kids.module';
import { YouthModule } from './modules/youth/youth.module';
import { WheelchairModule } from './modules/wheelchair/wheelchair.module';
import { ProfessionalModule } from './modules/professional/professional.module';
import { SeniorModule } from './modules/senior/senior.module';
import { ClassesModule } from './modules/classes/classes.module';
import { BeachtennisModule } from './modules/beachtennis/beachtennis.module';
import { CoachtrainingModule } from './modules/coachtraining/coachtraining.module';
import { ArbitrationModule } from './modules/arbitration/arbitration.module';
import { OnbudsmanModule } from './modules/onbudsman/onbudsman.module';
import { VideosModule } from './modules/videos/videos.module';
import { AdvertiseModule } from './modules/advertise/advertise.module';

/* Componentes */
import { AppComponent } from './app.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { registerLocaleData } from '@angular/common';
import localeBr from '@angular/common/locales/pt';

import { TokenService } from './core/services/token.service';
import { WINDOW_PROVIDERS } from './core/http/window.providers';
import { AppBaseComponent } from './app-base.component';
import { AuthService } from './modules/auth/auth.service';
import { NbDatepickerModule } from '@nebular/theme';

import { AuthGuardService } from './core/services/auth-guard.service';
import { LanguageService } from './core/services/language.service';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
/* ngx-translate */
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { UserService } from './modules/user/user.service';
import { TournamentModule } from './modules/tournament/tournament.module';
import { LoaderInterceptor } from './core/interceptors/loader-interceptor';
import { NgxSkeletonModule } from 'ngx-skeleton';
import { PrivacyInterceptorService } from './core/interceptors/privacy-interceptor.service';
import { ThemeModule } from './@theme/theme.module';
import { DateFnsConfigService } from '@core/services/date-fns-config.service';
import { HttpLoaderFactory } from '@core/services/loader-factory.service';

registerLocaleData(localeBr, 'pt');

@NgModule({
    declarations: [AppComponent, AppBaseComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NavigationModule,
        AuthModule,
        KidsModule,
        YouthModule,
        WheelchairModule,
        ProfessionalModule,
        SeniorModule,
        ClassesModule,
        BeachtennisModule,
        CoachtrainingModule,
        ArbitrationModule,
        NgbModule,
        HomeModule,
        FederationModule,
        OnbudsmanModule,
        VideosModule,
        AdvertiseModule,
        TournamentModule,
        NgxSkeletonModule,
        ThemeModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
    ],
    providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        { provide: LOCALE_ID, useValue: 'pt' },
        WINDOW_PROVIDERS,
        TokenService,
        AuthService,
        LanguageService,
        AuthGuardService,
        DateFnsConfigService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoaderInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PrivacyInterceptorService,
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
